import { Box, Divider } from '@wix/design-system';
import {
  Faq,
  NonBlockerWrapper,
  PageFooter,
  TrustBuilders,
  useDomainIntent,
  useIsTrustBuildersRedesign,
} from '@wix/package-picker-shared-eclipse';
import React from 'react';
import { AfnicSection } from '../../components/AfnicSection';
import { FeaturesGrid } from '../../components/FeaturesGrid';
import { EnterpriseBanner } from '../../components/EnterpriseBanner';
import { HeaderBanner } from '../../components/HeaderBanner';
import { PlansSection } from '../../components/PlansSection';
import { useQuickPayBack } from '../../components/QuickPayLightbox/QuickPayBackContext';

export const SelectPlanPage = () => {
  const gridRef = React.useRef<HTMLDivElement>(null);
  const isTrustBuildersRedesign = useIsTrustBuildersRedesign();
  const { isInFunnel, backToFunnel } = useDomainIntent();

  // Set only for the "Compare plans" step inside the lightbox: back returns to the plan card, taking precedence over the funnel's back.
  const backToLightbox = useQuickPayBack();

  return (
    <Box
      direction="vertical"
      width="100%"
      align="center"
      paddingBottom="SP6"
      boxSizing="border-box"
    >
      <HeaderBanner />
      <Box
        margin="0 auto"
        direction="vertical"
        width="100%"
        align="center"
        padding="0px 30px"
        boxSizing="border-box"
      >
        <PlansSection
          gridRef={gridRef}
          showTrustBuilders={!isTrustBuildersRedesign}
          showBackButton={Boolean(backToLightbox) || isInFunnel}
          onBack={backToLightbox ?? backToFunnel}
        />
        <Box width="100%" align="center" padding="0 SP5">
          <AfnicSection />
        </Box>
        <Box
          width="100%"
          align="center"
          marginTop="120px"
          padding="0 SP5"
          boxSizing="border-box"
        >
          <EnterpriseBanner />
        </Box>
        <Box width="100%" align="center" marginTop="120px" maxWidth="1320px">
          <FeaturesGrid innerRef={gridRef} />
        </Box>
        {isTrustBuildersRedesign && (
          <Box
            direction="vertical"
            gap="50px"
            marginTop="SP7"
            width="100%"
            maxWidth="1320px"
            padding="0 SP2"
            boxSizing="border-box"
          >
            <Divider />
            <TrustBuilders />
          </Box>
        )}
        <Box
          marginTop={isTrustBuildersRedesign ? '50px' : 'SP7'}
          width="100%"
        >
          <NonBlockerWrapper componentName="Faq">
            <Faq />
          </NonBlockerWrapper>
        </Box>
        <PageFooter />
      </Box>
    </Box>
  );
};
